import { render, staticRenderFns } from "./BlockListBorgerDkTextCustom.vue?vue&type=template&id=418c34d9&"
import script from "./BlockListBorgerDkTextCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListBorgerDkTextCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports